import { SortUtil } from '@iot-platform/iot-platform-utils';
import { FilterCategoryV2, FilterFieldV2 } from '../models';

export function getFavoriteFieldsByUserPreferences(
  categories: (FilterFieldV2 | FilterCategoryV2)[],
  favoriteFiltersByConcept: Record<string, Array<{ name: string; order: number }>>
): (FilterFieldV2 | FilterCategoryV2)[] {
  const favoriteFields: (FilterFieldV2 | FilterCategoryV2)[] = [];

  Object.entries(favoriteFiltersByConcept).forEach(([categoryKey, favoriteFiltersForCategory]) => {
    favoriteFiltersForCategory?.forEach((favoriteFilter) => {
      let field = null;

      // First, try to find in the original category
      const originalCategory = categories.find((cat) => cat.key === categoryKey);
      if (originalCategory) {
        if ((originalCategory as FilterCategoryV2)?.fields) {
          field = (originalCategory as FilterCategoryV2)?.fields?.find((f: any) => f.key === favoriteFilter.name);
        } else if ((originalCategory as FilterFieldV2).key === favoriteFilter.name) {
          field = originalCategory;
        }
      }

      // If not found in original category, search all categories (handles moved filters)
      if (!field) {
        for (const category of categories) {
          if ((category as FilterCategoryV2)?.fields) {
            field = (category as FilterCategoryV2)?.fields?.find((f: any) => f.key === favoriteFilter.name);
            if (field) break;
          } else if ((category as FilterFieldV2).key === favoriteFilter.name) {
            field = category;
            break;
          }
        }
      }

      // Add it to favorite fields if found
      if (field) {
        favoriteFields.push({
          ...field,
          order: favoriteFilter.order
        });
      }
      // If not found in any category, it's truly deprecated - skip it
    });
  });

  return favoriteFields.sort(SortUtil.sortByOrder);
}

export function getDefaultFavoriteFields(categories: (FilterFieldV2 | FilterCategoryV2)[]): (FilterFieldV2 | FilterCategoryV2)[] {
  const favorites: (FilterFieldV2 | FilterCategoryV2)[] = [];

  categories?.forEach((category) => {
    if ((category as FilterCategoryV2)?.fields) {
      (category as FilterCategoryV2)?.fields?.forEach((field: FilterFieldV2) => {
        if (field.defaultFavorite) {
          favorites.push(field);
        }
      });
    } else if ((category as FilterFieldV2)?.defaultFavorite) {
      favorites.push(category);
    }
  });

  return favorites.sort(SortUtil.sortByOrder);
}
